/* ============================================================================
   mt-restock.js — "Avísame cuando haya stock" (aviso de reposición)
   ----------------------------------------------------------------------------
   Muestra el botón solo cuando la TALLA elegida está agotada. Al tocarlo abre
   una ventana (<dialog>) con el resumen del producto y pide WhatsApp o correo.

   SOLO CHILE (doble candado):
     1. El snippet no se renderiza si el mercado no es Chile.
     2. Aquí solo se acepta un móvil chileno: 9 dígitos que parten en 9.
        El número siempre se envía normalizado como 56XXXXXXXXX.

   MODO PRUEBA: mientras LIVE = false, el bloque solo aparece para quien abra la
   web con ?mtaviso=on (queda guardado en ese navegador).
   ============================================================================ */
(function () {
  'use strict';

  var CONFIG = {
    // Endpoint del bot que registra el aviso. Vacío = modo vitrina (no guarda).
    ENDPOINT: 'https://whatsbot-kappa.vercel.app/restock/registrar',
    LIVE: true,    // ⬅️ ACTIVO para todas las clientas
    // SMTP configurado y probado (2026-09-04): la clienta elige canal.
    EMAIL: true,
    DEBUG: false
  };

  var STORAGE_KEY = 'mt_restock_avisos';

  // ---- Gate de modo prueba -------------------------------------------------
  function isEnabled() {
    if (CONFIG.LIVE) return true;
    try {
      var q = new URL(window.location.href).searchParams.get('mtaviso');
      if (q === 'on') localStorage.setItem('mt_aviso', 'on');
      if (q === 'off') localStorage.removeItem('mt_aviso');
      return localStorage.getItem('mt_aviso') === 'on';
    } catch (e) {
      return false;
    }
  }

  window.__mtRestock = window.__mtRestock || { loaded: false, mode: null, ver: 2, logs: [] };
  function log() {
    var msg = [].slice.call(arguments).join(' ');
    try {
      window.__mtRestock.logs.push(msg);
      if (window.__mtRestock.logs.length > 40) window.__mtRestock.logs.shift();
    } catch (e) {}
    if (CONFIG.DEBUG && window.console) console.log('[mt-restock]', msg);
  }

  // ---- Teléfono chileno ----------------------------------------------------
  // Acepta "9 1234 5678", "912345678", "+56 9 1234 5678", "56912345678".
  // Devuelve "56912345678" o null si no es un móvil chileno válido.
  function normalizeChileanMobile(raw) {
    var digits = String(raw || '').replace(/\D/g, '');
    if (digits.indexOf('56') === 0 && digits.length > 9) digits = digits.slice(2);
    if (digits.indexOf('0') === 0) digits = digits.slice(1);
    if (!/^9\d{8}$/.test(digits)) return null;
    return '56' + digits;
  }

  // Números que pasan el formato pero que no son de nadie: 999999999, 911111111,
  // 912345678, 987654321… El bot los rechaza igual; acá se avisa al tiro para
  // que la clienta corrija sin esperar la respuesta del servidor.
  function todosIguales(d) { return /^(\d)\1*$/.test(d); }

  function esSecuencia(d) {
    var sube = true, baja = true;
    for (var i = 1; i < d.length; i++) {
      var paso = Number(d[i]) - Number(d[i - 1]);
      if (paso !== 1) sube = false;
      if (paso !== -1) baja = false;
    }
    return sube || baja;
  }

  function esNumeroFalso(tel) {
    var d = String(tel || '').replace(/\D/g, '').replace(/^56/, '');
    if (!/^9\d{8}$/.test(d)) return false;
    var resto = d.slice(1);
    return todosIguales(d) || todosIguales(resto) || esSecuencia(d) || esSecuencia(resto);
  }

  function formatChileanMobile(raw) {
    var digits = String(raw || '').replace(/\D/g, '').slice(0, 9);
    if (digits.length <= 1) return digits;
    if (digits.length <= 5) return digits.slice(0, 1) + ' ' + digits.slice(1);
    return digits.slice(0, 1) + ' ' + digits.slice(1, 5) + ' ' + digits.slice(5);
  }

  // ---- Memoria local de avisos ya enviados ---------------------------------
  function savedSignups() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}') || {};
    } catch (e) {
      return {};
    }
  }

  function rememberSignup(variantId) {
    try {
      var all = savedSignups();
      all[String(variantId)] = Date.now();
      localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
    } catch (e) {}
  }

  function alreadySignedUp(variantId) {
    return Object.prototype.hasOwnProperty.call(savedSignups(), String(variantId));
  }

  // ==========================================================================
  function init() {
    var root = document.querySelector('[data-mt-restock]');
    if (!root) return;

    // Candado 1: solo Chile.
    if ((root.dataset.country || 'CL') !== 'CL') {
      log('mercado no chileno, no se muestra');
      return;
    }

    if (!isEnabled()) {
      log('modo prueba: oculto (abre la web con ?mtaviso=on para verlo)');
      return;
    }

    window.__mtRestock.loaded = true;
    window.__mtRestock.mode = CONFIG.LIVE ? 'LIVE' : 'PRUEBA';

    var variants = [];
    try {
      variants = JSON.parse(root.querySelector('[data-mt-restock-variants]').textContent) || [];
    } catch (e) {
      log('no pude leer las variantes');
      return;
    }

    var byId = {};
    variants.forEach(function (v) { byId[String(v.id)] = v; });

    var toggle = root.querySelector('[data-mt-toggle]');
    var modal = root.querySelector('[data-mt-modal]');
    var formView = root.querySelector('[data-mt-form]');
    var confirmar = root.querySelector('[data-mt-confirmar]');
    var confirmarSi = root.querySelector('[data-mt-confirmar-si]');
    var confirmarNo = root.querySelector('[data-mt-confirmar-no]');
    var numeroEl = root.querySelector('[data-mt-numero]');
    var exito = root.querySelector('[data-mt-exito]');
    var done = root.querySelector('[data-mt-done]');
    var field = root.querySelector('[data-mt-field]');
    var phone = root.querySelector('[data-mt-phone]');
    var errorEl = root.querySelector('[data-mt-error]');
    var submit = root.querySelector('[data-mt-submit]');
    var sizeBadge = root.querySelector('[data-mt-size-badge]');
    var precio = root.querySelector('[data-mt-precio]');
    var sizeExito = root.querySelector('[data-mt-size-exito]');
    var sizeDone = root.querySelector('[data-mt-size-done]');
    var canales = root.querySelector('[data-mt-canales]');
    var canalExito = root.querySelector('[data-mt-canal-exito]');
    var canalDone = root.querySelector('[data-mt-canal-done]');
    var note = root.querySelector('[data-mt-note]');
    var sub = root.querySelector('[data-mt-sub]');
    var emailInput = root.querySelector('[data-mt-email]');
    var campos = {
      whatsapp: root.querySelector('[data-mt-campo="whatsapp"]'),
      email: root.querySelector('[data-mt-campo="email"]')
    };
    var canal = 'whatsapp';

    // Copy del panel. Dos reglas: nunca decir "pedido" (todavía no compró nada) y
    // que cada frase prometa algo que el bot cumple de verdad — "una sola vez" es
    // literal: cron-restock saca a la clienta de la lista después de enviar.
    var TEXTOS = {
      whatsapp: {
        como: 'por WhatsApp',
        sub: 'Déjanos tu WhatsApp y te avisamos apenas vuelva.',
        nota: 'Te escribimos una sola vez, cuando vuelva. Solo números de Chile.',
        boton: 'Avísame por WhatsApp'
      },
      email: {
        como: 'por correo',
        sub: 'Déjanos tu correo y te avisamos apenas vuelva.',
        nota: 'Te escribimos una sola vez, cuando vuelva. Nada más.',
        boton: 'Avísame por correo'
      }
    };

    function setCanal(nuevo) {
      canal = nuevo;
      Array.prototype.forEach.call(root.querySelectorAll('[data-mt-canal]'), function (b) {
        var activo = b.dataset.mtCanal === nuevo;
        b.classList.toggle('is-active', activo);
        b.setAttribute('aria-pressed', activo ? 'true' : 'false');
      });
      if (campos.whatsapp) campos.whatsapp.hidden = nuevo !== 'whatsapp';
      if (campos.email) campos.email.hidden = nuevo !== 'email';
      if (canalExito) canalExito.textContent = TEXTOS[nuevo].como;
      if (canalDone) canalDone.textContent = TEXTOS[nuevo].como;
      if (note) note.textContent = TEXTOS[nuevo].nota;
      if (sub) sub.textContent = TEXTOS[nuevo].sub;
      submit.textContent = TEXTOS[nuevo].boton;
      hideError();
      var campo = nuevo === 'email' ? emailInput : phone;
      if (campo) campo.focus();
    }

    // Las opciones solo aparecen si el correo está disponible; si no, no tiene
    // sentido mostrar un botón que lleva a un callejón sin salida.
    if (CONFIG.EMAIL && canales) {
      canales.hidden = false;
      Array.prototype.forEach.call(root.querySelectorAll('[data-mt-canal]'), function (b) {
        b.addEventListener('click', function () { setCanal(b.dataset.mtCanal); });
      });
    }

    // ---- La ventana ---------------------------------------------------------
    // showModal() da el foco atrapado, el Esc y el estar por encima de todo sin
    // pelear con los z-index del tema. Si el navegador es viejo y no lo tiene,
    // se abre igual como panel normal en vez de dejar el botón muerto.
    var soportaModal = typeof modal.showModal === 'function';
    if (!soportaModal) modal.classList.add('mt-restock__modal--simple');

    function volverAlFormulario() {
      formView.hidden = false;
      confirmar.hidden = true;
      exito.hidden = true;
    }

    function abrir() {
      volverAlFormulario();
      hideError();
      if (soportaModal) {
        // Sin bloqueo de scroll a propósito: en Safari, poner overflow:hidden
        // en <html> devuelve la página al principio y la clienta pierde dónde
        // iba. La ventana es position:fixed, así que se queda quieta igual.
        modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }
      var campo = canal === 'email' ? emailInput : phone;
      if (campo) setTimeout(function () { campo.focus(); }, 50);
    }

    function cerrar() {
      if (soportaModal && modal.open) modal.close();
      else modal.removeAttribute('open');
    }

    toggle.addEventListener('click', abrir);

    Array.prototype.forEach.call(root.querySelectorAll('[data-mt-close]'), function (b) {
      b.addEventListener('click', cerrar);
    });

    // Tocar fuera de la tarjeta cierra. El <dialog> ocupa toda la pantalla, así
    // que un clic "en el fondo" llega con el propio dialog como target.
    modal.addEventListener('click', function (e) {
      if (e.target === modal) cerrar();
    });

    // Esc y el botón atrás del navegador disparan close(): devolver el scroll.
    modal.addEventListener('close', function () {
      toggle.focus();
    });

    // ---- Qué variante está elegida ahora -----------------------------------
    function selectedVariant() {
      // 1) Los radios del selector reflejan siempre lo que ve la clienta.
      var selector = document.querySelector('product-selector:not([data-context="modal"])');
      if (selector) {
        var chosen = Array.prototype.map.call(
          selector.querySelectorAll('input[type="radio"]:checked, select'),
          function (el) { return el.value; }
        );
        if (chosen.length) {
          var match = variants.filter(function (v) {
            return (v.options || []).length === chosen.length &&
              (v.options || []).every(function (o, i) { return o === chosen[i]; });
          })[0];
          if (match) return match;
        }
      }

      // 2) Campo oculto del formulario de compra.
      var form = document.getElementById(root.dataset.form);
      var input = form && form.querySelector('input[name="id"]');
      if (input && byId[String(input.value)]) return byId[String(input.value)];

      // 3) ?variant= en la URL.
      try {
        var fromUrl = new URL(window.location.href).searchParams.get('variant');
        if (fromUrl && byId[String(fromUrl)]) return byId[String(fromUrl)];
      } catch (e) {}

      return null;
    }

    // ---- Pintado -----------------------------------------------------------
    var shownVariantId = null;

    function labelFor(variant) {
      if (!variant) return '';
      return variant.size ? 'la talla ' + variant.size : 'este modelo';
    }

    function render() {
      var variant = selectedVariant();

      if (!variant || variant.available) {
        root.hidden = true;
        shownVariantId = null;
        if (modal.open) cerrar();
        return;
      }

      root.hidden = false;
      if (String(variant.id) === String(shownVariantId)) return;
      shownVariantId = variant.id;

      var text = labelFor(variant);
      if (sizeExito) sizeExito.textContent = text;
      if (sizeDone) sizeDone.textContent = text;
      if (sizeBadge) {
        sizeBadge.textContent = variant.size ? 'Talla ' + variant.size : '';
        sizeBadge.hidden = !variant.size;
      }
      if (precio) precio.textContent = variant.price || '';

      // Al cambiar de talla se vuelve al estado inicial de esa talla.
      if (alreadySignedUp(variant.id)) {
        toggle.hidden = true;
        done.hidden = false;
        if (modal.open) cerrar();
      } else {
        toggle.hidden = false;
        done.hidden = true;
        volverAlFormulario();
        hideError();
      }
      if (canalExito) canalExito.textContent = TEXTOS[canal].como;
      if (canalDone) canalDone.textContent = TEXTOS[canal].como;
      log('agotada:', variant.title);
    }

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = false;
      if (field) field.classList.add('is-invalid');
    }

    function hideError() {
      if (!errorEl) return;
      errorEl.hidden = true;
      errorEl.textContent = '';
      if (field) field.classList.remove('is-invalid');
    }

    // ---- Interacción --------------------------------------------------------
    if (phone) {
      phone.addEventListener('input', function () {
        var caretAtEnd = phone.selectionStart === phone.value.length;
        phone.value = formatChileanMobile(phone.value);
        if (caretAtEnd) phone.setSelectionRange(phone.value.length, phone.value.length);
        hideError();
      });
      phone.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); submit.click(); }
      });
    }

    if (emailInput) {
      emailInput.addEventListener('input', hideError);
      emailInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); submit.click(); }
      });
    }

    // Lo que quedó listo para enviar mientras la clienta confirma su número.
    var pendiente = null;

    function guardar(datos, variant, boton, etiqueta) {
      boton.disabled = true;
      boton.textContent = 'Anotándote…';

      send(datos).then(function (res) {
        boton.disabled = false;
        boton.textContent = etiqueta;
        if (!res || !res.ok) {
          // Volver al formulario: el error casi siempre se arregla corrigiendo
          // el número, y desde la pantalla de confirmar no se puede escribir.
          volverAlFormulario();
          // El bot devuelve el motivo en español (y a veces la corrección de
          // un typo); mostrarlo tal cual ayuda más que un mensaje genérico.
          showError((res && res.error) || 'No pudimos guardarlo. Intenta de nuevo en un momento.');
          return;
        }
        if (canalExito) canalExito.textContent = TEXTOS[canal].como;
        if (canalDone) canalDone.textContent = TEXTOS[canal].como;
        rememberSignup(variant.id);
        // La confirmación se muestra DENTRO de la ventana: cerrarla de golpe
        // se siente como si hubiera fallado. Al cerrarla, la ficha ya muestra
        // el aviso de "estás anotada" en vez del botón.
        formView.hidden = true;
        confirmar.hidden = true;
        exito.hidden = false;
        toggle.hidden = true;
        done.hidden = false;
        log('registrado por', canal, 'variante', variant.id);
      });
    }

    submit.addEventListener('click', function () {
      var variant = selectedVariant();
      if (!variant) return;

      var datos = {
        variantId: variant.id,
        size: variant.size || '',
        variantTitle: variant.title || '',
        productId: root.dataset.productId,
        productTitle: root.dataset.productTitle,
        productUrl: root.dataset.productUrl,
        source: 'web'
      };

      if (canal === 'email') {
        var correo = (emailInput && emailInput.value || '').trim();
        // Validación mínima acá; el bot revisa de verdad (y detecta typos).
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(correo)) {
          showError('Revisa el correo: parece que le falta algo. Ej: tucorreo@gmail.com');
          if (emailInput) emailInput.focus();
          return;
        }
        datos.email = correo;
        // El correo no pasa por confirmación: si está mal escrito, el bot
        // detecta el typo y devuelve la corrección en el mismo momento.
        guardar(datos, variant, submit, TEXTOS[canal].boton);
        return;
      }

      // Candado 2: solo móviles chilenos.
      var normalized = normalizeChileanMobile(phone && phone.value);
      if (!normalized) {
        showError('Revisa el número: en Chile son 9 dígitos y parten en 9.');
        if (phone) phone.focus();
        return;
      }
      if (esNumeroFalso(normalized)) {
        showError('Ese número no parece real. Revísalo, por favor.');
        if (phone) phone.focus();
        return;
      }
      datos.phone = normalized;

      // Un dedazo puede formar un número válido que es de otra persona, y no
      // existe forma de preguntarle a WhatsApp si el número es de quien dice
      // serlo. El último control es la clienta viendo lo que escribió.
      numeroEl.textContent = '+56 ' + formatChileanMobile(normalized.slice(2));
      pendiente = { datos: datos, variant: variant };
      formView.hidden = true;
      confirmar.hidden = false;
      confirmarSi.focus();
    });

    confirmarSi.addEventListener('click', function () {
      if (!pendiente) return;
      guardar(pendiente.datos, pendiente.variant, confirmarSi, 'Sí, es mi número');
    });

    confirmarNo.addEventListener('click', function () {
      pendiente = null;
      volverAlFormulario();
      if (phone) { phone.focus(); phone.select(); }
    });

    function send(payload) {
      if (!CONFIG.ENDPOINT) {
        // Modo vitrina: sin backend todavía, solo se muestra el flujo.
        log('VITRINA (no se guarda):', JSON.stringify(payload));
        return Promise.resolve({ ok: true });
      }
      return fetch(CONFIG.ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json().catch(function () { return { ok: r.ok }; }); })
        .catch(function (e) { log('error de red', e); return { ok: false }; });
    }

    // ---- Seguimiento del selector de tallas --------------------------------
    // El tema reemplaza <product-selector> completo al cambiar de talla, así que
    // no guardamos referencias: releemos el DOM en cada pasada.
    document.addEventListener('change', function () { setTimeout(render, 60); }, true);
    window.addEventListener('popstate', function () { setTimeout(render, 60); });
    setInterval(function () {
      if (document.visibilityState === 'visible') render();
    }, 600);

    render();
    log('activo (modo ' + (CONFIG.LIVE ? 'LIVE' : 'PRUEBA') + ')');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
